import { useState, useEffect } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import CustomSelect from "../CustomSelect";
import resetImg from "../../../../../picture/timer-language.png";

const istekDokumentaAll = [
  { id: "sve", name: "SVI DOKUMENTI" },
  { id: "1", name: "ISTEKLI DOKUMENTI" },
  { id: "2", name: "ISTIČU USKORO (ALARM)" },
  { id: "3", name: "VAŽEĆI DOKUMENTI" },
];

const radnaMestaAll = [
  { id: "sve", name: "SVA RADNA MESTA" },
  { id: "1", name: "Radno mesto 1" },
  { id: "2", name: "Radno mesto 2" },
  { id: "3", name: "Radno mesto 3" },
];

const poslovneJediniceAll = [
  { id: "sve", name: "SVE" },
  { id: "1", name: "Posl 1" },
  { id: "2", name: "Posl 2" },
  { id: "3", name: "Posl 3" },
];

const defaultPretraga = {
  radnoMesto: { id: "-1", name: "" },
  istekDokumenta: { id: "-1", name: "" },
  poslovnaJedinica: { id: "-1", name: "" },
  pretraga: "",
};

function PretragaZaposlenih({ onClose }) {
  const {
    dokumentaZaposlenihPretraga,
    setDokumentaZaposlenihPretraga,
    dictionary,
  } = useGlobalContext();

  const [pretraga, setPretraga] = useState(dokumentaZaposlenihPretraga || defaultPretraga);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    setPretraga(dokumentaZaposlenihPretraga || defaultPretraga);
    setIsDirty(false);
  }, [dokumentaZaposlenihPretraga]);

  const onSelectChangeRadnoMesto = (newValue) => {
    setPretraga((prev) => ({ ...prev, radnoMesto: newValue }));
    setIsDirty(true);
  };
  const onSelectChangeIstekDokumenta = (newValue) => {
    setPretraga((prev) => ({ ...prev, istekDokumenta: newValue }));
    setIsDirty(true);
  };
  const onSelectChangePoslovnaJedinica = (newValue) => {
    setPretraga((prev) => ({ ...prev, poslovnaJedinica: newValue }));
    setIsDirty(true);
  };
  const onChangePretraga = (e) => {
    setPretraga((prev) => ({ ...prev, pretraga: e.target.value }));
    setIsDirty(true);
  };

  const handlePretraga = () => {
    setDokumentaZaposlenihPretraga(pretraga);
    setIsDirty(false);
  };

  const handleReset = () => {
    setPretraga(defaultPretraga);
    setDokumentaZaposlenihPretraga(defaultPretraga);
    setIsDirty(false);
  };

  return (
    <div style={{ padding: "10px" }}>
      <CustomSelect
        label={dictionary["radnoMesto"]}
        allValues={radnaMestaAll}
        selectedValue={pretraga.radnoMesto}
        onSelectChange={onSelectChangeRadnoMesto}
      />
      <div style={{ margin: "5px 0" }} />
      <CustomSelect
        label={dictionary["poslovnaJedinica"]}
        allValues={poslovneJediniceAll}
        selectedValue={pretraga.poslovnaJedinica}
        onSelectChange={onSelectChangePoslovnaJedinica}
      />
      <div style={{ margin: "5px 0" }} />
      <CustomSelect
        label={dictionary["istekDokumenta"]}
        allValues={istekDokumentaAll}
        selectedValue={pretraga.istekDokumenta}
        onSelectChange={onSelectChangeIstekDokumenta}
      />
      <div style={{ margin: "5px 0" }} />
      <input
        value={pretraga.pretraga}
        onChange={onChangePretraga}
        placeholder={`${dictionary["pretraga"]}...`}
        style={{
          width: "100%",
          fontSize: "16px",
          height: "40px",
          padding: "10px",
        }}
      />

      <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <div
          onClick={() => {
            if (isDirty) handlePretraga();
            else onClose?.();
          }}
          style={{ flex: 8 }}
        >
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            {isDirty ? dictionary["pretrazi"] : dictionary["zatvori"] || "ZATVORI"}
          </Button>
        </div>

        <div onClick={handleReset} style={{ flex: 2 }}>
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            <img src={resetImg} alt="Reset" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PretragaZaposlenih;